import { useQuery, useQueryClient } from '@tanstack/react-query';
import { emptyFunction, handleApiResponse } from '@/functions';
import { IBioVerification } from '@/lib/interface';
import { apiClient } from '@/components/api';
import { GenderEnum } from '@/lib/enum';
import routes from '@/lib/routes';
import dayjs from 'dayjs';

type TParams = {
  gender?: GenderEnum;
  config?: {
    staleTime?: number;
  }
};
type TResponseData = IBioVerification[];

export const useRequestGetVerificationBio = (params?: TParams, run = true) => {

  const queryClient = useQueryClient();

  const staleTime = params?.config?.staleTime ?? queryClient.getDefaultOptions().queries?.staleTime as any;

  if (params?.config) {
    delete params.config;
  }

  const { isFetching: isLoadingVerifications, data, error, dataUpdatedAt: verificationsUpdatedAt, refetch } = useQuery({
    queryKey: [routes.api.verifications.bio, params, run],
    queryFn: ({ queryKey: [_url, _params, _run] }) =>
      !_run
        ? Promise.resolve(null)
        : apiClient
          .get<TResponseData>(_url as string, _params as TParams)
          .then(handleApiResponse)
          .then(data => data?.map(l => ({ ...l, createdAt: dayjs(l.createdAt).toDate() })) ?? []),
    staleTime
  });

  const verifications = (data ?? []);

  return ({
    refreshVerifications: () => refetch()
                                  .then(emptyFunction),
    isLoadingVerifications,
    verificationsUpdatedAt,
    verifications,
    error
  });

};
